import React from 'react';
import {Radio, RadioGroup} from '@chakra-ui/react';
import {Controller} from 'react-hook-form';

const PreArrangeRadio = ({control, data, id}) => {
  const preArrange = [
    {key: 'Yes', value: 1},
    {key: 'No', value: 2},
    {key: 'Done', value: 3},
    {key: 'N/A', value: 4},
  ];

  return (
    <Controller
      name={id}
      control={control}
      defaultValue={data[id] ?? 2}
      render={({field}) => (
        <RadioGroup {...field} onChange={e => field.onChange(parseInt(e))} style={{display: 'contents'}}>
          {preArrange.map(item => {
            return (
              <Radio key={item.value} colorScheme={'tertiary'} value={item.value} ml="3">
                {item.key}
              </Radio>
            );
          })}
        </RadioGroup>
      )}
    />
  );
};

export default PreArrangeRadio;
